module.exports = __webpack_public_path__ + "static/media/movie3.3b849ab6.mp4";